<template>
  <div>
    <el-dialog title :visible.sync="dialogVisible" width="550px" :before-close="handleClose">
      <div slot="title" class="ta-c">
        <i class="el-icon-warning fc-407FFF"></i> 请确保照片边框完整、自己清晰及亮度均衡
      </div>
      <div class="image-content">
        <img class="image-card mr15" src="@/assets/login/image-example1.png" alt />
        <img class="image-card" src="@/assets/login/image-example2.png" alt />
        <img class="image-card" v-if="flag=='official'" src="@/assets/login/image-example3.png" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      flag: ""
    };
  },
  methods: {
    show(flag) {
      this.flag = flag;
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 20px;
}
.image-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.image-card {
  width: 240px;
  height: 165px;
}
</style>